import { render } from '@testing-library/react';
import React, { Component, useEffect, useState, useLayoutEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { GeoserverGetCapabilities } from '../../services/geoserver/GeoserverCapabilities';
import Meses from '../../services/Meses';
import NoticiasApi from '../../services/robinhood/NoticiasApi';
import ParceirosApi from 'services/robinhood/ParceirosApi';

export default function MenuParceiros() {

  const meses = Meses;
  const [anos, setAnos] = useState([]);
  const [menu, setMenu] = useState(new Date().getFullYear());
  const [parceiros, setParceiros] = useState([]);

  useEffect(() => {

    new ParceirosApi().parcerias().then(response => {
      setParceiros(response);
    })
  }, [])

  const handlerMenu = (ano) => {
    if (menu == ano)
      setMenu(null);
    else
      setMenu(ano);
  }

  const CatalogItem = (props) => {
    return (
      <>
        <ul className="ml-menu" style={{ display: 'block' }}>
          {parceiros.map(parceiro =>
            <li key={Math.random()} >
              <Link to={'/parceiros'} key={Math.random()} state={{ parceiro: { 'id': parceiro.id, 'parceiro': parceiro.parceiro, 'nome': parceiro.parceiro_nome }, 'key': Math.random() }} className="waves-effect waves-classic" style={{ fontWeight: '', fontSize: '14px', paddingTop: '2px', paddingBottom: '2px' }} >
                <span className='text-capitalize' style={{ textTransform: 'capitalize' }}> {parceiro.parceiro} </span>
              </Link>
            </li>
          )}
        </ul>
      </>
    );
  }

  return (
    <>
      <div className="menu">
        <ul className="list">
          <li className="header"><strong> <i className='zmdi zmdi-accounts m-r-5'></i>  &nbsp;PARCEIROS ENVOLVIDOS </strong></li>
          <CatalogItem></CatalogItem>
          {/* <li ><a href="http://robin-hood-historico.fjp.mg.gov.br/index.php/parceiros" target='_blank' className="waves-effect waves-block"><i className="zmdi zmdi-link"></i><span> DEMAIS DE PARCEIROS </span> </a></li > */}
        </ul>
      </div>
    </>
  );

}
